/* eslint-disable */
const PriceRangeObjectValue = Backbone.Model.extend({
	defaults: {
		from: null,
		to: null
	}
});

export default PriceRangeObjectValue;